<template>
    <v-row no-gutters :class="$vuetify.breakpoint.smAndDown ? 'mt-1' : ''">
        <v-col>
            <NoteDialog
                v-if="editDialog.show"
                :note="editDialog.note"
                :show-dialog="editDialog.show"
                :forcedActiveTabType="editDialog.note.type"
                @change="noteChanged"
                @close="closeEditDialog"
            ></NoteDialog>

            <div>
                <div class="rounded-lg white overflow-hidden elevation-4">
                    <div class="d-none">
                        <input
                            ref="files_input"
                            type="file"
                            multiple
                            @change="handleFilesUpload()"
                        />
                    </div>
                    <div class="px-2">
                        <NoteTabs
                            :note-topics="note_topics"
                            :active-tab="activeTab"
                            @change="onChangeTab"
                        />
                    </div>
                    <NoteEditView
                        ref="noteEditView"
                        :edit-note="{}"
                        :comments="comments"
                        :handle-files-upload="handleFilesUpload"
                        @change="comments = $event"
                    />
                    <div class="py-3 px-4">
                        <NoteFooter
                            :files="files"
                            :uploaded-files="uploaded_files"
                            :remove-file="removeFile"
                            :remove-uploaded-file="removeUploadedFile"
                            :add-link="addLink"
                            :add-files="addFiles"
                            :save-note-click="saveNoteClick"
                            :loader="loader"
                            :edit-note="{}"
                            :toggle-is-pinned="toggleIsPinned"
                            :is-pinned="isPinned"
                        />
                    </div>
                </div>
            </div>
            <v-tabs
                v-if="clientNotes.length"
                v-model="active_tab"
                background-color="transparent"
                class="denser-tabs pt-4 pb-0"
                slider-size="4"
            >
                <v-tab v-for="tab in tabs" :key="tab.value">
                    <span class="caption font-weight-medium">{{ tab.text }}</span>
                </v-tab>
            </v-tabs>
            <v-card class="profile-notes elevation-4" :flat="$vuetify.breakpoint.smAndDown">
                <v-row
                    v-for="note in clientNotes.filter(
                        n => n.type === tabs[active_tab].value || tabs[active_tab].value === 'all'
                    )"
                    :key="note.id"
                    no-gutters
                    :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'py-1 d-flex justify-space-between'"
                >
                    <v-col class="shrink mx-4">
                        <v-avatar
                            v-if="note.account"
                            :color="note.account.avatar ? 'white' : 'grey'"
                            size="22"
                        >
                            <img
                                v-if="note.account.avatar"
                                :alt="note.account.initials"
                                :src="note.account.avatar"
                            />
                            <span v-else class="caption white--text">
                                {{ note.account.initials }}
                            </span>
                        </v-avatar>
                    </v-col>
                    <v-col class="note-text-area">
                        <span class="body-2 font-weight-medium">{{
                            note.account ? note.account.full_name : ""
                        }}</span>
                        <div class="body-2 pt-1" v-html="note.comments"></div> <!-- INPUT CLEANED WHEN SAVING -->
                        <div :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'py-1'">
                            <fileChip
                                v-for="(file, index) in note.files"
                                :key="index"
                                :file-name="file.file_name"
                                class="mr-2"
                                @click:action="onFileChipClick(file)"
                                @click:close="removeFile(file)"
                            />
                        </div>
                        <div class="pb-2">
                            <v-chip
                                small
                                color="shade_color"
                                text-color="grey darken-1"
                                class="text-uppercase font-weight-medium"
                            >
                                {{ tabs.find(x => x.value === note.type).text }}
                            </v-chip>
                            <span class="caption mx-3 grey--text font-weight-medium">
                                {{ note.updated_at | format_datetime }}
                            </span>
                        </div>
                    </v-col>
                    <v-col class="shrink px-1">
                        <v-btn
                            small
                            :color="isNotePinned(note.id, relatedId, relatedType) ? 'orange' : 'grey'"
                            icon
                            @click="onPinNoteClick(note.id)"
                        >
                            <v-icon>mdi-pin</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col class="shrink pr-3 pl-2">
                        <v-menu content-class="overflow-y-hidden dropmenu" bottom offset-y left>
                            <template v-slot:activator="{ on }">
                                <v-btn small icon v-on="on">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item
                                    class="menu-list-item"
                                    style="height: 32px !important; min-height: 32px !important;"
                                    @click="onEditNoteClick(note)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ $t("Edit") }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    class="menu-list-item"
                                    style="height: 32px !important; min-height: 32px !important;"
                                    @click="onDeleteNoteClick(note.id)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ $t("Delete") }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import Vue from "vue";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import { computed, ref, watch, onMounted } from "@vue/composition-api";
import NoteModule from "../../store/modules/note";
import DialogModule from "../../store/modules/dialog";
import fileChip from "../../components/fileChip";
import NoteEditView from "../Note/NoteEditView";
import NoteDialog from "../Note/NoteDialog";
import { Router } from "../../composables/Router";
import { $t } from "@/i18n";
import { syncItemToList, removeFromList } from "../../plugins/formatting";
import NoteFooter from "@/views/Note/NoteFooter.vue";
import UseNoteEdit from "@/composables/NoteEdit";
import NoteTabs from "@/views/Note/NoteTabs.vue";
import {downloadFile} from '../../helpers/helpers'

const useNavigation = function() {
    const active_tab = ref(0);
    const tabs = [
        { text: $t("All"), value: "all" },
        { text: $t("Notes"), value: "info" },
        { text: $t("Document"), value: "document" },
        { text: $t("Email"), value: "email" },
        { text: $t("Billing"), value: "billing" },
    ];
    return {
        active_tab,
        tabs
    };
};

export default {
    name: "NotesView",
    components: {
        NoteTabs,
        NoteFooter,
        fileChip,
        NoteEditView,
        NoteDialog
    },
    props: {
        relatedType: {
            type: String,
            required: true
        },
        relatedId: {
            type: Number,
            default: 0
        }
    },
    setup(props, ctx) {
        const { pinNote, deleteNote, fetchNotes, isNotePinned } = NoteModule();
        const { openConfirmDialog, setConfirmOptions, setDialogOptions, openDialog } = DialogModule();
        const { tabs, active_tab } = useNavigation();
        const router = Router();
        const files_input = ref(null)
        const noteEditView = ref(null)

        const clientNotes = ref([]);
        const editDialog = ref({ show: false, note: null });
        const client_id = computed(() => router.currentRoute.params.id);
        const relatedIdWatch = computed(() => props.relatedId);

        const richTextEditor = computed(() => {
            return noteEditView.value.$refs.richTextEditor
        })

        const onPinNoteClick = note_id => {
            pinNote(note_id)
                .then(resp => {
                    syncItemToList(clientNotes.value, resp);
                })
                .catch((ex) => errorDialog.showError(ex));
        };
        const loadData = () => {
            fetchNotes(props.relatedType, props.relatedId)
                .then(resp => {
                    clientNotes.value = resp;
                })
                .catch((ex) => errorDialog.showError(ex));
        }

        const onFileChipClick = async file => {
            try {
                await downloadFile('note_attachment', file)
            } catch (e) {
                errorDialog.showError(e)
            }
        };
        const onEditNoteClick = note => {
            editDialog.value.note = note;
            editDialog.value.show = true;
        };
        const closeEditDialog = () => {
            editDialog.value.show = false;
            editDialog.value.note = null;
        };

        const onDeleteNoteClick = note_id => {
            const onDeleteNoteConfirm = () => {
                deleteNote(note_id)
                    .then(() => {
                        removeFromList(clientNotes.value, note_id);
                    })
                    .catch((ex) => errorDialog.showError(ex));
            };
            setConfirmOptions({
                title: $t("Notice!"),
                text: $t("Are you sure that you want to delete this?"),
                confirm_text: $t("Confirm"),
                cancel_text: $t("Cancel"),
                action: onDeleteNoteConfirm
            });
            openConfirmDialog();
        };
        const noteChanged = note => {
            syncItemToList(clientNotes.value, note, "id", true);
        };

        watch(relatedIdWatch, () => {
            loadData();
        })

        const setFocus = () => {
            noteEditView.value.$refs.richTextEditor.$refs.richTextEditorContent.$el.querySelector(".ql-editor").focus()
        }

        const onChangeTab = (value) => {
            activeTab.value = value
            setFocus()
        }

        onMounted(() => {
            setTimeout(function() {
                setFocus()
            }, 300);
        });

        const {
            files,
            uploaded_files,
            removeFile,
            removeUploadedFile,
            addLink,
            addFiles,
            saveNoteClick,
            loader,
            editNote,
            activeTab,
            note_topics,
            comments,
            handleFilesUpload,
            toggleIsPinned,
            isPinned,
        } = UseNoteEdit(props.relatedType, props.relatedId, null, noteChanged, files_input, richTextEditor)

        return {
            editDialog,
            onEditNoteClick,
            onDeleteNoteClick,
            onPinNoteClick,
            onFileChipClick,
            clientNotes,
            client_id,
            active_tab,
            tabs,
            noteChanged,
            closeEditDialog,
            files,
            uploaded_files,
            removeFile,
            removeUploadedFile,
            addLink,
            addFiles,
            saveNoteClick,
            loader,
            editNote,
            activeTab,
            note_topics,
            comments,
            handleFilesUpload,
            files_input,
            noteEditView,
            isNotePinned,
            toggleIsPinned,
            isPinned,
            onChangeTab
        };
    }
};
</script>

<style scoped lang="scss">
::v-deep .quill-editor .ql-container div.ql-editor {
    border-left: 0 !important;
    border-right: 0 !important;
    border-radius: 0 !important;
}
</style>